<template>
  <div class="products-kww-online-page-content flex flex-col items-center w-full text-left">
    <!-- banner 包含移动端 -->
    <PageBanner :content="content.bannerInfo" />

    <PageBusinessCol :content="content.businessIntroduction" />

    <!-- 产品功能介绍 中间左右布局的内容 -->
    <PageFunction :content="content.featuresIntroduction" />

    <!-- 产品优势 -->
    <PageAdvantage :content="content.advantage" :extraTitleStyle="{ color: '#272E3B' }" />

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '口味王线上商城'
const description = '品牌直营全品类线上聚合商城'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  bannerInfo: {
    banner: '/images/pages/products/kww-online/xs- (3).png',
    mobileBanner: '/images/mobile/products/kwwxssc.png'
  },
  businessIntroduction: {
    title: '产品业务介绍',
    description: [
      '2023年和贵科技自主研发的商城,支持企业线上开店,将用户引导到私域进行全国的销售',
      '当前最成功的标杆客户口味王集团在该小程序已有累计超1600W+粉丝基数，销售额每年可达2000W+以上',
    ],
    descImage: '/images/pages/products/kww-online/c-0.png',
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    extraCardBackColor: 'bg-#FAFAFA',
    extraTitleClass: 'bg-#FAFAFA w-100%!',
    groups: [
      {
        title: '商家管理',
        desc: '',
        descList: [
          '对入驻线上商城的各类商家信息进行集中管理',
        ],
        icon: '/images/pages/products/kww-online/f-i- (1).png',
        mainImage: '/images/pages/products/kww-online/f- (1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '商品管理',
        desc: '',
        descList: ['对线上商城所售商品的管理，包括商品信息录入、上下架操作、价格调整等',],
        icon: '/images/pages/products/kww-online/f-i- (2).png',
        mainImage: '/images/pages/products/kww-online/f- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '订单管理',
        desc: '',
        descList: ['线上产生的订单进行全流程跟踪与管理'],
        icon: '/images/pages/products/kww-online/f-i- (3).png',
        mainImage: '/images/pages/products/kww-online/xs- (5).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '会员管理',
        desc: '',
        descList: ['包含会员注册信息、会员充值、会员标签等。',],
        icon: '/images/pages/products/kww-online/f-i- (4).png',
        mainImage: '/images/pages/products/kww-online/xs- (1).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '积分商城',
        desc: '',
        descList: ['会员可使用积累的积分兑换各类商品或服务，同时支持积分规则设定与积分使用记录管理',],
        icon: '/images/pages/products/kww-online/f-i- (5).png',
        mainImage: '/images/pages/products/kww-online/xs- (4).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '仓库管理',
        desc: '',
        descList: ['线上商城仓库及快递公司的创建和维护，物流和库存查询',],
        icon: '/images/pages/products/kww-online/f-i- (6).png',
        mainImage: '/images/pages/products/kww-online/xs- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '运营数据管理',
        desc: '',
        descList: ['收集、整理与分析线上商城运营过程中产生的各类数据，为商城运营决策提供有力的数据支持',],
        icon: '/images/pages/products/kww-online/f-i- (7).png',
        mainImage: '/images/pages/products/kww-online/f- (7).png',
        direction: 'image-to-copywriting'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    // background: '/images/pages/products/kww-online/b-back.png',
    list: [
      {
        briefBack: '/images/pages/products/kww-online/b- (2).png',
      },
      {
        briefBack: '/images/pages/products/kww-online/b- (4).png',
      },
      {
        briefBack: '/images/pages/products/kww-online/b- (3).png',
      },
      {
        briefBack: '/images/pages/products/kww-online/b- (1).png',
      },
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-kww-online-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .kww-online-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/kww-online/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/kww-online/圆点.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.kww-online-product-advantage {
  background-image: url("/images/pages/products/kww-online/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
